import axios, {AxiosResponse} from 'axios';
import {useToast} from "@chakra-ui/react";

const httpClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

interface FetchParams {
    page?: number,
    limit?: number,
    sort?: any
}

export function useHttpClient() {
    const toast = useToast();

    async function joinWaitListApi(payload) {
        return httpClient.post("/api/v1/waitlist/create-waitlist?platform=project_x", {
            ...payload,
            platform: payload.platform || "project_x"
        });
    }

    async function getWaitListCountApi() {
        return httpClient.post("/api/v1/waitlist/get-waitlist-count", {
            platform: "project_x"
        });
    }

    return {
        joinWaitListApi,
        getWaitListCountApi
    };
}
